import { defineMessages } from '@jutro/locale';

export default defineMessages({

    recentHistoryandNotesTab: {
        id: 'gateway.actvityandNotes.RECENT NOTES & HISTORY',
        defaultMessage: 'RECENT NOTES & HISTORY'
    },
    pendingFollowUpsTab: {
        id: 'gateway.actvityandNotes.RECENT NOTES & HISTORY',
        defaultMessage: 'PENDING FOLLOW-UPS'
    },
    completedTransactions: {
        id: 'gateway.actvityandNotes.RECENT NOTES & HISTORY',
        defaultMessage: 'COMPLETED TRANSACTIONS'
    },
    errorLoadingNotes: {
        id: 'gateway.actvityandNotes.notes.error',
        defaultMessage: 'Error loading notes'
    },
    categoryNotAvailable: {
        id: 'gateway.actvityandNotes.notes.category no longer available',
        defaultMessage: 'Category no longer available'
    }
});
